import React, { useEffect } from "react";
import { withRouter, useHistory } from "react-router-dom";
import liff from "@line/liff";
import AppConfig from "./AppConfig.json";
import axios from "axios";
import { connect } from "react-redux";
import * as actions from "./actions";
import AATagging from "./AATagging";

export function UnlinkScreen({
  access_token,
  line_access_token,
  user_type,
  member_id,
}) {
  let history = useHistory();
  useEffect(() => {
    AATagging.trackAlreadyLink(member_id, user_type === "t");
  }, []);

  async function unlink() {
    try {
      let result = await axios.post(
        `${AppConfig.endpoint}/member/unlink`,
        {
          access_token,
        },
        {
          headers: {
            "x-access-token": line_access_token,
            "x-api-key": AppConfig.api_key,
          },
        }
      );

      if (result.data && result.data.success) {
        signOut(false);
        history.push(`/member/message/unlinked?u=${user_type}&m=${member_id}`);
      }
    } catch (err) {
      console.error("Unlink error:", err);
    }
  }

  async function signOut(close = true) {
    try {
      await axios.post(
        `${AppConfig.endpoint}/member/signout`,
        {
          access_token,
        },
        {
          headers: {
            "x-access-token": line_access_token,
            "x-api-key": AppConfig.api_key,
          },
        }
      );
    } catch (err) {
      console.error("Signout error:", err);
    }
    if (close && liff.isInClient()) {
      liff.closeWindow();
    }
  }

  async function redirectToSignup(line_access_token) {
    let result = await axios.post(
      `${AppConfig.endpoint}/member/binding`,
      { mode: "signup" },
      {
        headers: {
          "x-access-token": line_access_token,
          "x-api-key": AppConfig.api_key,
        },
      }
    );

    // setMessage(JSON.stringify(result.data))
    if (result.data && result.data.url) {
      window.location.href = result.data.url;
    }
  }

  return (
    <div className="error-page has-text-centered" style={{ paddingTop: 40 }}>
      <img alt="" src="/linked_with_partner.png" style={{ width: 240 }} />
      <div className="subtitle">
        This The 1 account has been linked with another LINE ID!
      </div>
      <p>
        If you don’t have your own The 1 account, please create one. Or if this
        The 1 account belongs to you, please unlink the other LINE ID and link
        with yours instead.
      </p>

      <div className="screen-footer">
        <button
          className="button is-fullwidth is-save"
          style={{ marginTop: 10 }}
          onClick={() => {
            AATagging.trackAlreadyLinkCreateThe1(member_id, user_type === "t");
            signOut(false);
            setTimeout(() => {
              redirectToSignup(line_access_token);
            }, 1500);
          }}
        >
          Create your own The 1 account
        </button>
        <button
          className="button is-fullwidth is-outlined"
          style={{ marginTop: 10 }}
          onClick={() => {
            AATagging.trackAlreadyLinkUnlink(member_id, user_type === "t");
            setTimeout(() => {
              unlink();
            }, 1500);
          }}
        >
          Unlink with the other LINE ID
        </button>
        <button
          className="button is-outlined"
          style={{ marginTop: 10 }}
          onClick={() => {
            signOut();
          }}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}

export default withRouter(connect((state) => state, actions)(UnlinkScreen));
